export { default as TimetableList } from './TimetableList';



// WEBPACK FOOTER //
// ./src/modules/Timetable/pages/index.ts